export default "__VITE_ASSET__CD9eE2zT__"